export default function homeShareholderTabs() {
    $(".home-shareholder-tabs").tabslet({
        container: '#shareholderTabContainer'
    });
};
